'use client'
import { LinkExternal } from '@/types/common/LinkExternal'
import s from './FlexImages.module.scss'
import { useContext, useEffect, useState } from 'react'
import Link from 'next/link'
import React from 'react'
import LazyImage from '@/components/common/LazyImage'
import { Image } from '@/types/common/ImageData'

interface FlexImagesProps {
    data: DataProps
}

interface DataProps {
    _type: string;
    _ref: string;
    images: Array<Image>;
}

export default function FlexImagesComponent({
    data
}: FlexImagesProps) {

    return (
        <div className={s.flexImages}>
            {data.images && data.images.map((item: Image, index: number) => (
                <div key={`flex-image-${index}`} className={s.flexImage}>
                    <LazyImage
                        src={item.imageUrl}
                        width={item.metadata.dimensions.width}
                        height={item.metadata.dimensions.height}
                        blurDataURL={item.ref}
                        fill={false}
                        alt={item.attribution || ""}
                        caption={item.caption || null}
                        filename={item.filename || ""}
                    />
                </div>
            ))}
        </div>
    )
}
